import * as z from "zod";

export const getEmailTemplateNames = {
  name: "getEmailTemplateNames" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({ emailTemplateIdToNameMap: z.map(z.string(), z.string()) }),
};
